customElements.whenDefined('slider-component').then(() => {
  if (customElements.get('collection-list-carousel')) return;

  class CollectionListCarousel extends SliderComponent {
    constructor() {
      super();
      this._layoutRefreshRaf = null;
      queueMicrotask(() => this.refreshLayout());
    }

    connectedCallback() {
      this.refreshLayout();
      this._onSectionLoad = (event) => {
        if (event.target.contains(this)) this.refreshLayout();
      };
      document.addEventListener('shopify:section:load', this._onSectionLoad);
    }

    disconnectedCallback() {
      if (this._onSectionLoad) {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
      }
      if (this._layoutRefreshRaf) cancelAnimationFrame(this._layoutRefreshRaf);
    }

    refreshLayout() {
      if (this._layoutRefreshRaf) cancelAnimationFrame(this._layoutRefreshRaf);

      this._layoutRefreshRaf = requestAnimationFrame(() => {
        this._layoutRefreshRaf = requestAnimationFrame(() => {
          this._layoutRefreshRaf = null;
          if (typeof this.resetPages === 'function') this.resetPages();
          this.updateArrowVisibility();
        });
      });
    }

    update() {
      super.update();
      this.updateArrowVisibility();
    }

    updateArrowVisibility() {
      if (!this.slider) return;

      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const hasScroll = maxScroll > 1;

      this.classList.toggle('is-scrollable', hasScroll);
      this.classList.toggle('is-at-start', this.slider.scrollLeft <= 1);
      this.classList.toggle('is-at-end', this.slider.scrollLeft >= maxScroll - 1);
    }
  }

  customElements.define('collection-list-carousel', CollectionListCarousel);
});
